import {category} from "@/store/modules/catalog/category";
import {filter} from "@/store/modules/catalog/filter";

export const Catalog = {
    namespaced: true,
    modules: {
        category: category,
        filter: filter
    }
}